<template>
  <div>
    <v-dialog v-model="dialogCategoria" width="500">
      <categoria-create
        :categoriaPadre="parent"
        @save-category="registrarCategoria"
        @refresh-categorias="$emit('refresh-categorias')"
        @cerrar-dialog="$emit('close-dialog')"
      ></categoria-create>
    </v-dialog>
  </div>
</template>
<script>
import CategoriaCreate from "@/components/categorias/categoria.create";
import ProductosAPI from "@/api/productos";
export default {
  name: "ProductoCategoriaCreate",
  components: {
    CategoriaCreate,
  },
  props: {
    parent: {
      type: Object,
    },
    dialogCategoria: {
      type: Boolean,
    },
  },
  methods: {
    registrarCategoria(categoria) {
      const data = {
        padre: this.parent.id,
        nombre: [categoria.name],
        uso: categoria.uso,
      };

      ProductosAPI.createCategoria(data)
        .then(() => {
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: `Categoría registrada`,
            icon: "mdi-check-circle-outline",
            timeout: 3000,
          });
          this.$emit("refresh-categorias");
          this.$emit("close-dialog");
        })
        .catch((e) => {
          const mensaje =
            e.response?.data?.detail || "No se pudo registrar la categoría";

          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "error",
            text: mensaje,
            icon: "mdi-alert-circle-outline",
            timeout: 4000,
          });
          this.$emit("close-dialog");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>